<template>
  <div>
    <div class="colorBlock">开票信息</div>
    <!--    <el-row :gutter="10" type="">-->
    <!--      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"></el-col>-->

    <!--      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"><label>发票抬头名称：</label>-->
    <!--        <el-input disabled size="mini" v-hovertip="formData.invoiceTitle" v-model="formData.invoiceTitle" />-->
    <!--      </el-col>-->

    <!--      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"><label>联系电话：</label>-->
    <!--        <el-input disabled size="mini" v-hovertip="formData.invoicePhone" v-model="formData.invoicePhone" />-->
    <!--      </el-col>-->

    <!--      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"><label>企业税号：</label>-->
    <!--        <el-input disabled size="mini" v-hovertip="formData.invoiceIdentifierNo"-->
    <!--                  v-model="formData.invoiceIdentifierNo" />-->
    <!--      </el-col>-->

    <!--      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"><label>开户银行：</label>-->
    <!--        <el-input disabled size="mini" v-hovertip="formData.invoiceOpenBank" v-model="formData.invoiceOpenBank" />-->
    <!--      </el-col>-->

    <!--      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"><label>企业地址：</label>-->
    <!--        <el-input disabled size="mini" v-hovertip="formData.invoiceEnterpriseAddress"-->
    <!--                  v-model="formData.invoiceEnterpriseAddress" />-->
    <!--      </el-col>-->

    <!--      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"><label>银行账号：</label>-->
    <!--        <el-input disabled size="mini" v-hovertip="formData.invoiceBankNo" v-model="formData.invoiceBankNo" />-->
    <!--      </el-col>-->
    <!--    </el-row>-->
    <div class="box">
      <div>
        <label>发票抬头名称：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.invoiceTitle"
          v-model="formData.invoiceTitle"
        />
      </div>
      <div>
        <label>联系电话：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.invoicePhone"
          v-model="formData.invoicePhone"
        />
      </div>
      <div>
        <label>企业税号：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.invoiceIdentifierNo"
          v-model="formData.invoiceIdentifierNo"
        />
      </div>
      <div>
        <label>开户银行：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.invoiceOpenBank"
          v-model="formData.invoiceOpenBank"
        />
      </div>
      <div>
        <label>企业地址：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.invoiceEnterpriseAddress"
          v-model="formData.invoiceEnterpriseAddress"
        />
      </div>
      <div>
        <label>银行账号：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.invoiceBankNo"
          v-model="formData.invoiceBankNo"
        />
      </div>
      <div v-if="formData.invoiceMethod !== null">
        <label>开票方式：</label>
        <el-input
          size="mini"
          :value="formData.invoiceMethod === 1 ? '电子发票' : '纸质发票'"
          disabled
        />
      </div>
    </div>
    <div class="colorBlock">发票邮寄信息</div>
    <div class="box">
      <div>
        <label>收件人：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.receiptFullName"
          v-model="formData.receiptFullName"
        />
      </div>
      <div>
        <label>联系方式：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.receiptPhone"
          v-model="formData.receiptPhone"
        />
      </div>
      <div>
        <label>发票邮寄地址：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.receiptAddress"
          v-model="formData.receiptAddress"
        />
      </div>
      <div>
        <label>收件地址名称：</label>
        <el-input
          size="mini"
          v-hovertip="formData.receiptAddressName"
          v-model="formData.receiptAddressName"
          disabled
        />
      </div>
      <div>
        <label>邮箱：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.email"
          v-model="formData.email"
        />
      </div>
    </div>
    <div class="colorBlock">开票内容</div>
    <div class="box">
      <div>
        <label>开票类目：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.itemName"
          v-model="formData.itemName"
        />
      </div>
      <div>
        <label>发票类别：</label>
        <el-input
          disabled
          size="mini"
          v-hovertip="formData.invoiceTypeName"
          v-model="formData.invoiceTypeName"
        />
      </div>
      <div>
        <label>开票金额：</label>
        <el-input disabled size="mini" :value="money" />
      </div>
    </div>
    <div v-if="firstFlag">
      <div class="colorBlock">上传发票</div>
      <ul class="box">
        <label>发票照片：</label>
        <li v-for="item in firstData.imgList" :key="item.id">
          <img :src="item.invoicePic" @click="picDownLoad(item)" />
        </li>
      </ul>
      <ul class="box">
        <label>发票编号：</label>
        <li v-for="item in firstData.imgList" :key="item.id">
          <el-input
            size="mini"
            v-hovertip="item.invoiceNo"
            :value="item.invoiceNo"
            class="picInput"
            disabled
          />
        </li>
      </ul>
      <ul
        class="box"
        v-if="firstData.fileList.length > 0"
        style="align-items:baseline;"
      >
        <label>附件文件：</label>
        <div style="flex-direction:column;">
          <li
            v-for="(items, findex) in firstData.fileList"
            :key="findex"
            style="margin-bottom:20px;"
          >
            <el-link @click="downLoadFile(items.fileUrl)" type="primary">
              {{ items.fileName }}
            </el-link>
          </li>
        </div>
      </ul>
      <div class="colorBlock">物流信息</div>
      <el-radio-group
        size="mini"
        v-hovertip="firstData.isMail"
        v-model="firstData.isMail"
        class="radioGroup"
        disabled
      >
        <el-radio :label="1">邮寄</el-radio>
        <el-radio :label="0">非邮寄</el-radio>
      </el-radio-group>
      <div class="box shadowBox" v-if="firstData.isMail">
        <label>公司名称：</label>
        <el-input
          size="mini"
          v-hovertip="firstData.companyName"
          :value="firstData.companyName"
          style="width:280px;margin-bottom:0;margin-right:80px;"
          disabled
        />
        <label>快递单号：</label>
        <el-input
          size="mini"
          v-hovertip="firstData.trackingNo"
          :value="firstData.trackingNo"
          style="width:280px;;margin-bottom:0;margin-right:0"
          disabled
        />
      </div>
    </div>
    <div v-for="item in leftList" :key="item.id">
      <div class="head">
        <div class="left">补充材料（{{ item.importType }}）</div>
        <div class="right">{{ item.createDt | transAllTime }} 补充上传</div>
      </div>
      <div>
        <div class="colorBlock">上传发票</div>
        <ul class="box">
          <label>发票照片：</label>
          <li v-for="item2 in item.imgList" :key="item2.id">
            <img :src="item2.invoicePic" @click="picDownLoad(item2)" />
          </li>
        </ul>
        <ul class="box">
          <label>发票编号：</label>
          <li v-for="item2 in item.imgList" :key="item2.id">
            <el-input
              size="mini"
              v-hovertip="item2.invoiceNo"
              :value="item2.invoiceNo"
              class="picInput"
              disabled
            />
          </li>
        </ul>
        <ul
          class="box"
          v-if="item.fileList.length > 0"
          style="align-items:baseline;"
        >
          <label>附件文件：</label>
          <div style="flex-direction:column;">
            <li
              v-for="(item2, index2) in item.fileList"
              :key="index2"
              style="margin-bottom:20px;"
            >
              <el-link @click="downLoadFile(item2.fileUrl)" type="primary">
                {{ item2.fileName }}
              </el-link>
            </li>
          </div>
        </ul>
        <div class="colorBlock">物流信息</div>
        <el-radio-group
          size="mini"
          v-hovertip="item.isMail"
          v-model="item.isMail"
          class="radioGroup"
          disabled
        >
          <el-radio :label="1">邮寄</el-radio>
          <el-radio :label="0">非邮寄</el-radio>
        </el-radio-group>
        <div class="box shadowBox" v-if="item.isMail">
          <label>公司名称：</label>
          <el-input
            size="mini"
            v-hovertip="item.companyName"
            :value="item.companyName"
            style="width:280px;margin-bottom:0;margin-right:80px;"
            disabled
          />
          <label>快递单号：</label>
          <el-input
            size="mini"
            v-hovertip="item.trackingNo"
            :value="item.trackingNo"
            style="width:280px;;margin-bottom:0;margin-right:0"
            disabled
          />
        </div>
        <div class="colorBlock box">备注说明</div>
        <div style="width:1090px;text-align:left;margin-top:20px;">
          <el-input
            size="mini"
            v-hovertip="item.remark"
            :value="item.remark"
            placeholder="无"
            disabled
            style="margin-left:50px;"
          />
        </div>
      </div>
    </div>
    <template v-if="isAudit">
      <div class="colorBlock box">审核操作</div>
      <div style="padding:20px">
        <el-radio-group v-model="invoiceStatus">
          <el-radio
            v-for="item in invoiceStatusList"
            :key="item.value"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
        <div v-if="invoiceStatus == 3" style="display:flex;padding:20px 0;">
          <span style="width: 100px">驳回原因：</span>
          <el-input
            type="textarea"
            placeholder="请输入内容"
            size="mini"
            v-model.trim="noPassReason"
            maxlength="200"
            show-word-limit
            :rows="6"
            style="width: 50%"
          />
        </div>
      </div>
    </template>
    <el-dialog
      class="picBox"
      :visible="picFlag"
      width="1033px"
      :show-close="false"
      :append-to-body="true"
    >
      <img :src="picUrl" />
      <div class="btnBox">
        <el-button type="primary" @click="downLoad">下载</el-button>
        <el-button type="primary" plain @click="picFlag = false">
          确认
        </el-button>
      </div>
    </el-dialog>
    <el-button
      block
      style="margin:35px auto 0;display:block"
      type="primary"
      @click="onConfirm"
      v-if="isAudit"
    >
      {{ isAudit ? '提交' : '确认' }}
    </el-button>
  </div>
</template>
<script>
import { invoice, protocolService } from '@/api/ajax';

export default {
  components: {},
  props: {
    itemData: {
      type: Object,
      default() {
        return {};
      }
    },
    isAudit: Boolean,
    saveSuccess: {
      type: Function,
      default() {
        return () => {};
      }
    }
  },
  data() {
    return {
      formData: {},
      firstFlag: false,
      leftList: [],
      firstData: {},
      money: '',
      picUrl: '',
      picFlag: false,
      invoiceStatus: 2, // 2 已开票 3 已驳回
      invoiceStatusList: [
        { label: '发票通过', value: 2 },
        { label: '发票驳回', value: 3 }
      ],
      noPassReason: '' // 驳回原因
    };
  },
  computed: {
    // 4 5类型
    is45() {
      return [4, 5].includes(this.formData.invoiceBusinessType);
    }
  },
  methods: {
    async onConfirm() {
      if (this.invoiceStatus === 3 && !this.noPassReason) {
        this.$message({
          type: 'error',
          message: '请您填写驳回原因'
        });
        return false;
      }
      await invoice.reviewTheSubmitted({
        id: this.formData.id,
        invoiceStatus: this.invoiceStatus,
        noPassReason: this.noPassReason
      });
      this.saveSuccess();
      this.$xrkDialog.remove();
    },
    downLoadFile(fileUrl) {
      //下载
      window.open(
        protocolService.downloadAgreementServiceFile +
          '?' +
          'fileUrl=' +
          fileUrl
      );
    },
    picDownLoad(item) {
      this.picUrl = item.invoicePic;
      this.picFlag = true;
    },
    downLoad() {
      //下载图片地址和图片名
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous');
      image.onload = function() {
        try {
          let canvas = document.createElement('canvas');
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext('2d');
          context.drawImage(image, 0, 0, image.width, image.height);
          let url = canvas.toDataURL('image/png'); //得到图片的base64编码数据
          let a = document.createElement('a'); // 生成一个a元素
          let event = new MouseEvent('click'); // 创建一个单击事件
          a.download = name || '发票'; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
        } catch (e) {
          console.info('生成下载出错', e);
        }
      };
      image.src = this.picUrl;
    },
    close() {},
    dealMoney(num) {
      if (!isNaN(num)) {
        let n = Number(num) / 100;
        if (/^\d+(\.\d{1})$/.test(n)) {
          return n + '0元';
        } else if (!/\./.test(n)) {
          return n + '.00元';
        } else {
          return n + '元';
        }
      } else {
        return 0;
      }
    }
  },
  async created() {
    const {
      data: { data }
    } = await invoice.queryInvoiceDetail({
      id: this.itemData.data.id
    });
    this.formData = data;
    this.money = this.dealMoney(data.invoiceAmount);
    if (data.detailList.length > 0) {
      for (let item of data.detailList) {
        if (item.importType === 0) {
          this.firstData = item;
          this.firstFlag = true;
        } else {
          this.leftList.push(item);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.picBox {
  padding: 0 30px 30px;
  border-radius: 12px;
  img {
    border: 1px solid #979797;
    width: 973px;
  }
  .btnBox {
    margin: auto;
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
    width: 60%;
  }
}
.colorBlock {
  font-size: 20px;
  line-height: 25px;
  display: flex;
  font-weight: bold;
  margin-top: 20px;
}
.colorBlock::before {
  content: '';
  width: 10px;
  height: 25px;
  background: #1989fa;
  margin-right: 5px;
  display: inline-block;
}
.shadowBox {
  width: 1100px;
  padding: 15px 0;
  background: #f5f7fa;
  margin: 20px 0 80px 50px;
}
.box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 15px 0;
  > div {
    display: flex;
    align-items: center;
    margin-right: 130px;
    margin-bottom: 20px;
  }
  label {
    color: #333333;
    font-size: 14px;
    width: 150px;
    text-align: right;
  }
  img {
    width: 174px;
    height: 112px;
  }
  .picInput {
    width: 174px;
    box-sizing: border-box;
  }
  li {
    margin-right: 48px;
  }
}
.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid #efefef;
  width: 100%;
  margin-bottom: 40px;
  margin-top: 15px;
  .left {
    color: #9b9b9b;
    font-size: 20px;
  }
  .right {
    font-size: 14px;
    color: #9b9b9b;
  }
}
.radioGroup {
  display: flex;
  margin-top: 20px;
  justify-content: flex-start;
}
</style>
